<template>
	<v-card rounded="xl" class="pa-2">
		<div class="cd-header">
			<v-avatar size="46" color="#1565c0">
				<img v-if="customer.photo" alt="user" :src="customer.photo" />
				<span v-else class="white--text text-h6">
					{{ customer.fullName.charAt(0)
					}}{{ customer.fullName.charAt(1) }}
				</span>
			</v-avatar>
			<div>
				<p class="cd-name">{{ customer.fullName }}</p>
				<p class="cd-sub">Informations personnelles</p>
			</div>
			<v-spacer></v-spacer>
			<v-btn icon small @click="$emit('close-customer-details-dialog')">
				<v-icon color="#6b7280">mdi-close</v-icon>
			</v-btn>
		</div>

		<v-divider></v-divider>

		<v-card-text class="pt-4 px-4 pb-2">
			<v-list dense class="cd-list">
				<v-list-item class="cd-item px-0">
					<div class="cd-item-icon">
						<v-icon size="16" color="#1565c0">mdi-cake-variant</v-icon>
					</div>
					<div class="cd-item-content">
						<p class="cd-item-label">Date de naissance</p>
						<p class="cd-item-value">
							{{ customer.birthday || "Non précisé" }}
						</p>
					</div>
				</v-list-item>

				<v-divider class="my-1"></v-divider>

				<v-list-item class="cd-item px-0">
					<div class="cd-item-icon">
						<v-icon size="16" color="#1565c0">mdi-phone</v-icon>
					</div>
					<div class="cd-item-content">
						<p class="cd-item-label">Téléphone</p>
						<p class="cd-item-value">{{ customer.phone }}</p>
					</div>
				</v-list-item>

				<v-divider class="my-1"></v-divider>

				<v-list-item class="cd-item px-0">
					<div class="cd-item-icon">
						<v-icon size="16" color="#1565c0">mdi-email</v-icon>
					</div>
					<div class="cd-item-content">
						<p class="cd-item-label">Email</p>
						<p class="cd-item-value">{{ customer.email }}</p>
					</div>
				</v-list-item>

				<v-divider class="my-1"></v-divider>

				<v-list-item class="cd-item px-0">
					<div class="cd-item-icon">
						<v-icon size="16" color="#1565c0">mdi-map-marker</v-icon>
					</div>
					<div class="cd-item-content">
						<p class="cd-item-label">Adresse</p>
						<p class="cd-item-value">
							{{ customer.address || "Non précisé" }}
						</p>
					</div>
				</v-list-item>

				<v-divider class="my-1"></v-divider>

				<v-list-item class="cd-item px-0">
					<div class="cd-item-icon">
						<v-icon size="16" color="#1565c0">mdi-briefcase</v-icon>
					</div>
					<div class="cd-item-content">
						<p class="cd-item-label">Profession</p>
						<p class="cd-item-value">
							{{ customer.profession || "Non précisé" }}
						</p>
					</div>
				</v-list-item>

				<v-divider class="my-1"></v-divider>

				<v-list-item class="cd-item px-0">
					<div class="cd-item-icon">
						<v-icon size="16" color="#c62828"
							>mdi-weight-lifter</v-icon
						>
					</div>
					<div class="cd-item-content">
						<p class="cd-item-label">Morphologie</p>
						<p class="cd-item-value">
							{{ customer.weight }} kg — {{ customer.height }} m
						</p>
					</div>
				</v-list-item>
			</v-list>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	props: ["customer"],
};
</script>

<style scoped>
.cd-header {
	display: flex;
	align-items: center;
	gap: 14px;
	padding: 18px 20px 14px;
}
.cd-name {
	font-size: 0.95rem;
	font-weight: 700;
	color: #111827;
	margin: 0 0 2px;
	font-family: Montserrat, sans-serif;
}
.cd-sub {
	font-size: 0.72rem;
	color: #9ca3af;
	margin: 0;
	font-family: Montserrat, sans-serif;
}
.cd-list {
	background: transparent !important;
}
.cd-item {
	display: flex;
	align-items: flex-start;
	gap: 12px;
	padding: 8px 0 !important;
	min-height: unset !important;
}
.cd-item-icon {
	width: 30px;
	height: 30px;
	border-radius: 8px;
	background: #f1f5f9;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	margin-top: 2px;
}
.cd-item-content {
	flex: 1;
}
.cd-item-label {
	font-size: 0.68rem;
	font-weight: 600;
	color: #9ca3af;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	margin: 0 0 2px;
	font-family: Montserrat, sans-serif;
}
.cd-item-value {
	font-size: 0.85rem;
	font-weight: 600;
	color: #111827;
	margin: 0;
	font-family: Montserrat, sans-serif;
}
</style>
